export class Location {
    constructor(page, listener = () => { }) {
        this.page = page;
        this.listener = listener;
        this.isTracking = false;
        this.locationupdatedhandler = (ev) => this.handleLocationEvent(ev);
        // works on anchors
        this.preventNavigation = (ev) => {
            var _a, _b;
            if (!this.page.isOwner) {
                ev.preventDefault();
                // @ts-ignore
                ev.returnValue = "";
            }
            // @ts-expect-error
            else if ((_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.href) {
                // @ts-expect-error
                const target = new URL((_b = document.activeElement) === null || _b === void 0 ? void 0 : _b.href);
                if (target.hostname !== window.location.hostname) {
                    ev.preventDefault();
                    // @ts-ignore
                    ev.returnValue = "";
                }
            }
        };
        this.page
            .getWindow()
            .addEventListener("beforeunload", this.preventNavigation);
    }
    track() {
        this.handleLocationEvent();
        if (this.isTracking) {
            return;
        }
        this.page
            .getWindow()
            .addEventListener("popstate", this.locationupdatedhandler);
        this.isTracking = true;
    }
    untrack() {
        var _a;
        removeEventListener("beforeunload", this.preventNavigation);
        if (!this.isTracking) {
            return;
        }
        (_a = this.page
            .getWindow()) === null || _a === void 0 ? void 0 : _a.removeEventListener("popstate", this.locationupdatedhandler);
        this.isTracking = false;
    }
    handleLocationEvent(ev) {
        this.listener({
            synthetic: !ev,
            href: this.page.getDocument().location.href,
            base: this.page.getDocument().baseURI,
        });
    }
}
//# sourceMappingURL=location.js.map